import { useState } from 'react';
import { Box, Button } from '@mui/material';
import { AdditionalDetail } from './setbacks-more-additional-info';
import { RegridResponse } from '../../../../models/regrid.model.tsx';
import { translateZoningInfoNumberToString } from '../../../../utils/zoning-info.ts';

interface SetbacksMoreInfoProps {
  selectedOverlay: string;
  setShowingBuilderViewLayersModal: (val: boolean) => void;
  regridData: RegridResponse | undefined;
}

export const SetbacksMoreInfo = ({
  selectedOverlay,
  setShowingBuilderViewLayersModal,
  regridData,
}: SetbacksMoreInfoProps) => {
  const [showingMoreInfo, setShowingMoreInfo] = useState(false);

  return (
    <Box>
      <Button
        variant="outlined"
        onClick={() =>
          selectedOverlay === 'Setbacks'
            ? setShowingMoreInfo(!showingMoreInfo)
            : setShowingBuilderViewLayersModal(true)
        }
        sx={{
          background: 'white',
          marginTop: '12px',
          marginRight: '24px',
          minWidth: '48px',
        }}
      >
        DETAILS
      </Button>
      {showingMoreInfo && (
        <Box
          sx={{
            background: 'white',
            border: '0.33px solid',
            borderColor: '#9E9E9E',
            marginTop: '10px',
            padding: '8px 34px 18px 34px',
          }}
        >
          <AdditionalDetail
            detailTitle={'Front Setback'}
            detailValue={translateZoningInfoNumberToString(
              regridData?.zoningInformation.minimumFrontSetbackFeet,
              ' feet minimum'
            )}
          />
          <AdditionalDetail
            detailTitle={'Rear Setback'}
            detailValue={translateZoningInfoNumberToString(
              regridData?.zoningInformation.minimumRearSetbackFeet,
              ' feet minimum'
            )}
          />
          <AdditionalDetail
            detailTitle={'Side Setback'}
            detailValue={translateZoningInfoNumberToString(
              regridData?.zoningInformation.minimumSideSetbackFeet,
              ' feet minimum'
            )}
          />
          <AdditionalDetail
            detailTitle={'Maximum Coverage'}
            detailValue={translateZoningInfoNumberToString(
              regridData?.zoningInformation.maximumCoveragePercentage,
              '% total coverage'
            )}
          />
          <AdditionalDetail
            detailTitle={'Maximum Impervious Coverage'}
            detailValue={translateZoningInfoNumberToString(
              regridData?.zoningInformation.maximumImperviousCoveragePercentage,
              '% total coverage'
            )}
          />
          <AdditionalDetail
            detailTitle={'Minimum Landscaped Space'}
            detailValue={translateZoningInfoNumberToString(
              regridData?.zoningInformation.minimumLandscapedSpacePercentage,
              '% landscaped space'
            )}
          />
          <AdditionalDetail
            detailTitle={'Minimum Open Space'}
            detailValue={translateZoningInfoNumberToString(
              regridData?.zoningInformation.minimumOpenSpacePercentage,
              '% open minimum space'
            )}
          />
          <AdditionalDetail
            detailTitle={'Height Restrictions'}
            detailValue={
              regridData?.zoningInformation.maximumBuildingHeightFeet
                ? translateZoningInfoNumberToString(
                    regridData?.zoningInformation.maximumBuildingHeightFeet,
                    ' maximum feet'
                  )
                : 'No'
            }
          />
        </Box>
      )}
    </Box>
  );
};
